<template>
    <div class="msg-carousel pb-1">
        <div :id="'carousel_box_' + boxindex"
             class="scrolling-wrapper-flexbox"
             @mousedown="event_mouse_down"
             @mouseleave="event_mouse_leave"
             @mouseup="event_mouse_up"
             @mousemove="event_mouse_move">
            <div class="card" v-for="(crs, i) in carousels" :key="i">
                <v-hover>
                    <div class="cr-box" style="position: relative;">
                        <v-img aspect-ratio="0.9" @click="showLightBox(i)" contain :src="crs.image_url"/>
                        <div class="card-title">
                            <div class="sub-title-1" :title="crs.title">{{crs.title}}</div>
                            <div class="sub-title-2" v-html="replaceLinkInTextContent(crs.subtitle)"></div>
                        </div>
                    </div>
                </v-hover>
                <div class="carousel-img-button-display" v-if="crs.buttons && crs.buttons.length > 0">
                    <!-- check if button is not webview -->
                    <button 
                            v-for="(b, ib) in crs.buttons"
                            :key="ib"
                            :style="[
                                buttonCustomUI,
                                buttonHovered === b ? buttonCustomUIHover : {}
                                ]"
                            @mouseover="changeButtonHovered(b)"
                            @mouseleave="changeButtonHovered(-1)"
                            @click="btn_msg_click(b)">
                        {{ b.title }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import handlerMessage from '../../business/handler_messages'
import handlerData from '../../business/handler_data'
import { mapState } from 'vuex'
import BaseBox from "@/components/ChatBoxElement/BaseBox";

export default {
    name    : 'ChatCarouselBox',
    extends: BaseBox,
    props   : {
        content : null,
        boxindex: '',
        buttonHovered : -1
    },
    data() {
        return {
            isMouseDown: false,
            startX     : 0,
            scrollLeft : 0,
            carousels  : []
        }
    },
    mounted() {
        try {
            if (this.content.carousel_cards && this.content.carousel_cards.length > 0) {
                this.carousels = this.content.carousel_cards
            }
        } catch (e) {
            console.log(e)
        }
    },
    computed: {
        ...mapState(['styles'])
    },
    methods : {
        showLightBox(index) {
            let items = []
            this.carousels.map(item => {
                items.push({
                    title      : item.title,
                    description: item.subtitle,
                    src        : item.image_url
                })
            })
            this.$store.dispatch(this.$ActionTypes.SET_LIGHT_BOX_DATA_THEN_SHOW, {
                data: items,
                index
            })
        },
        event_mouse_down(e) {
            this.isMouseDown = true
            this.startX      = e.pageX - $('#carousel_box_' + this.boxindex + '.scrolling-wrapper-flexbox')[0].offsetLeft
            this.scrollLeft  = $('#carousel_box_' + this.boxindex + '.scrolling-wrapper-flexbox')[0].scrollLeft
        },

        event_mouse_leave(e) {
            this.isMouseDown = false
        },

        event_mouse_up(e) {
            this.isMouseDown = false
        },

        event_mouse_move(e) {
            if (!this.isMouseDown) return
            e.preventDefault()
            const x    = e.pageX - $('#carousel_box_' + this.boxindex + '.scrolling-wrapper-flexbox')[0].offsetLeft
            const walk = (x - this.startX) * 3 //scroll-fast
            //
            $('#carousel_box_' + this.boxindex + '.scrolling-wrapper-flexbox')[0].scrollLeft = this.scrollLeft - walk
            // console.log(walk);
        },

        btn_msg_click(btn_detail) {
            // console.log(btn_detail);
            if (btn_detail.payload && btn_detail.payload !== '') {
                let send_msg_content = btn_detail.payload
                if (send_msg_content.indexOf('#') >= 0) {
                    send_msg_content += '#' + btn_detail.title
                } else {
                    send_msg_content += '##' + btn_detail.title
                }
                // console.log(send_msg_content)
                handlerMessage.send_message_to_socket('payload', send_msg_content, this.$store.state.subChannel)
            } else if (btn_detail.url && btn_detail.url !== '') {
                // handler url
                handlerData.clickOpenLink(btn_detail.url)
            } else if (btn_detail.phone_call && btn_detail.phone_call !== '') {
                // phone call
                handlerData.clickCallPhone(btn_detail.phone_call)
            } else if (btn_detail.webview && btn_detail.webview !== "") {
                // handler webview
                if (this.$store.state.componentsMainApp) {
                this.$store.state.componentsMainApp.open_webview('', btn_detail.webview);
                }
            }
        },
        replaceLinkInTextContent(content) {
            return handlerData.urlify(content)
        },
        changeButtonHovered(value){
            this.buttonHovered = value
        },
    }
}
</script>

<style lang="scss" scoped>
    .no-hover {
    background-color: inherit !important;
    color: inherit !important;
    border: none !important;
    outline: none !important;
    }
    .scrolling-wrapper {
        overflow-x                 : scroll;
        overflow-y                 : hidden;
        white-space                : nowrap;
        -webkit-overflow-scrolling : touch;
        .card {
            display          : inline-block;
            width            : calc(100% - 80px);
            height           : 300px;
            margin           : 5px;
            background-color : antiquewhite;
        }
    }
    .scrolling-wrapper-flexbox {
        display         : flex;
        flex-wrap       : nowrap;
        overflow-x      : auto;
        scrollbar-width : thin;
        .card {
            flex      : 0 0 auto;
            width     : 196px;
            min-width : 196px;
            // height: 300px;
            margin    : 5px;
            // background-color: antiquewhite;
            // border: 1px solid lightgrey;
            // border-radius: 5px;
            padding   : 5px;
            .carousel_title {
                overflow      : hidden;
                text-overflow : ellipsis;
                width         : 100%;
                white-space   : nowrap;
            }
            .card-title {
                position   : absolute;
                bottom     : 0;
                /* background-color: black; */
                background : rgba(0, 0, 0, 0.5);
                color      : #fff;
                padding    : 5px 2px;
                width      : 100%;
                .sub-title-1,
                .sub-title-2 {
                    width         : 100%;
                    overflow      : hidden;
                    white-space   : nowrap;
                    text-overflow : ellipsis;
                    text-align    : center;
                }
                .sub-title-1 {
                    font-size   : 16px;
                    font-weight : bold;
                }
                .sub-title-2 {
                    font-size : 14px;
                }
            }
            .carousel-img-button-display {
                width : 100%;
                button {
                    width            : 100%;
                    height           : 30px;
                    padding          : 3px 20px;
                    border-top       : 1px solid white;
                    background-color : #b4b4b4;
                    color            : white;
                    border-radius    : 0 0 4px 4px;
                    opacity          : 1;
                    overflow         : hidden;
                    white-space      : nowrap;
                    text-overflow    : ellipsis;
                    outline          : none;
                }
                button:hover {
                    opacity : 0.7;
                }
                button:last-child {
                    border-bottom-left-radius  : 10px;
                    border-bottom-right-radius : 10px;
                }
            }
            .cr-box {
                position      : relative;
                overflow      : hidden;
                border-radius : 10px 10px 0 0;
                background    : rgba(0, 0, 0, 0.5);
            }
        }
    }
    .scrolling-wrapper-flexbox::-webkit-scrollbar-track {
        // -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color : #f5f5f5;
    }
    .scrolling-wrapper-flexbox::-webkit-scrollbar {
        height           : 3px;
        background-color : #f5f5f5;
    }
    .scrolling-wrapper-flexbox::-webkit-scrollbar-thumb {
        background-color : #b5b5b5;
        // border: 2px solid #b5b5b5;
    }
    .scrolling-wrapper-flexbox .card:first-child {
        margin-left : 0;
    }
    .scrolling-wrapper-flexbox .card:last-child {
        margin-right : 0;
    }
</style>
